import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var Container = function (props) {
    return (_jsx(React.Fragment, { children: _jsx("div", { className: 'container', children: props.children }) }));
};
